import { newId } from "../ids.js";
import { isoString, systemClock, type Clock } from "../time.js";
import type { Calendar, CalendarInput } from "./types.js";

/** Build a new Calendar record from user input. Pure: doesn't persist. */
export function createCalendar(input: CalendarInput, now: Clock = systemClock): Calendar {
  const ts = isoString(now());
  return {
    id: newId(),
    name: input.name.trim(),
    color: input.color ?? null,
    hidden: input.hidden ?? false,
    owner_id: input.owner_id ?? null,
    external_calendar_id: input.external_calendar_id ?? null,
    external_source: input.external_source ?? null,
    external_account: input.external_account ?? null,
    sync_direction: input.sync_direction ?? "off",
    sync_token: input.sync_token ?? null,
    last_synced_at: input.last_synced_at ?? null,
    created_at: ts,
    updated_at: ts,
    deleted_at: null,
  };
}
